import {ActionTypes} from '../constants/ActionTypes';

const initialState = "";
export const errors = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ERROR_MSG:
      return getErrors(state, action);
  }
  return state;
}

function getErrors(state, action) {
  if (action.checkError === true) {
    state = action.msg
    return state;
  } else {
    return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/errors.js